<div class="music" (mouseenter)="isHover=true" (mouseleave)="isHover=false">
    <audio #audioElement></audio>
    <img [src]="isPlaying?'../../../assets/icons/pause.svg':isHover?'../../../assets/icons/play.svg':'../../../assets/icons/play.svg'" class="music-icon"
    (click)="playAudio()" />
</div>
  